import { CreateFloorPlanMemoDiagramParams, WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/rects/`;

export const createFloorPlanMemoDiagram = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
  coordinates,
  style,
}: WithBranchParams<CreateFloorPlanMemoDiagramParams>) => {
  const url = createApiUrl(branchUid, floorPlanId);
  const { data } = await axiosInstance.post(url, {
    coordinates,
    style: {
      fill: style.fill,
      border_color: style.borderColor ?? null,
      opacity: style.opacity,
    },
    version: branchVersionId,
  });

  return data;
};
